import languagesJson from "@myvp/shared/src/i18n/languages.json"
import createResolveSupportedLocale from "@myvp/shared/src/i18n/resolve-supported-locale"

type Locale = Readonly<(typeof languagesJson)["languages"][number]>
const supportedLanguages = languagesJson.languages.filter(
  (language) => language.tag === "en-US"
)
export const LOCALES: readonly Locale[] = supportedLanguages
export const ALL_LOCALES: readonly Locale[] = languagesJson.languages

export const SUPPORTED_LOCALES = {
  enUS: languagesJson.shorthands.enUS,
}

export const resolveSupportedLocale = createResolveSupportedLocale({
  languages: LOCALES,
  shorthands: SUPPORTED_LOCALES,
})
